import React from 'react';
import { Section, FadeIn } from './ui';
export function AboutSection() {
  return <Section bg="bg-cream-light" id="sobre-mi" data-id="element-16">
      <FadeIn data-id="element-17">
        <div className="grid md:grid-cols-[auto_1fr] gap-10 md:gap-14 items-center max-w-4xl mx-auto" data-id="element-18">
          {/* Photo */}
          <div className="flex justify-center md:justify-start" data-id="element-19">
            <div className="w-44 h-44 md:w-56 md:h-56 rounded-full overflow-hidden shadow-lg shadow-brown/10 border-4 border-white shrink-0" data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/o3xaQFBEgfptD4xt1pJGZp/Estrella.png" alt="Estrella, fundadora de Edad Radiante" className="w-full h-full object-cover" data-id="element-21" />
            </div>
          </div>

          {/* Text */}
          <div className="text-center md:text-left" data-id="element-22">
            <span className="inline-flex items-center gap-2 text-coral font-bold tracking-wider uppercase text-sm mb-4" data-id="element-23">
              De mí para ti
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-brown mb-6 leading-tight" data-id="element-24">
              Yo también estuve donde{' '}
              <span className="text-gold italic font-normal" data-id="element-25">
                tú estás ahora
              </span>
            </h2>
            <div className="space-y-4 text-lg text-brown leading-relaxed" data-id="element-26">
              <p data-id="element-27">
                <span className="font-bold" data-id="element-28">
                  Soy Estrella, 62 años, fundadora de Edad Radiante.
                </span>{' '}
                Por años me levantaba agotada y corría al café esperando que ese
                primer sorbo me devolviera la vida. No funcionaba. Y nadie me
                decía por qué. Solo escuchaba: "es normal a tu edad."
              </p>
              <p className="italic text-brown-light" data-id="element-29">
                Me sentía invisible dentro de mi propio cuerpo. No era la vida
                que quería vivir.
              </p>
              <p data-id="element-30">
                Hasta que entendí que mi cuerpo no me estaba fallando,
                simplemente había cambiado las reglas y nadie me había dado el
                nuevo manual.
              </p>
              <p data-id="element-31">
                Hoy empiezo diferente. Sin carrera al café. Con energía real.
                Con claridad. Y con la certeza de que este cambio también es
                posible para ti.
              </p>
              <p data-id="element-32">
                Edad Radiante nació de mi propia transformación, para que tú no
                tardes tanto como yo en descubrirla.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}